import { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import useModal from "hooks/useModal";

const fileTypes = ["csv", "xlsx", "pdf"];

const DownloadReportButton = ({
  disabled,
  filename,
  getPayload,
  onDownload,
}) => {
  const [show, toggle] = useModal();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const downloadBlob = (blob, fileType) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${filename}.${fileType}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <Button
        color="primary"
        size="sm"
        disabled={disabled}
        onClick={toggle}
      >
        <i className="bx bx-download me-2" />
        {t("Download Report")}
      </Button>
      <Modal isOpen={show} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>{t("Download Report")}</ModalHeader>
        <ModalBody>
          <AvForm
            onValidSubmit={async (event, values) => {
              setLoading(true);
              try {
                const blob = await onDownload({
                  ...getPayload(),
                  fileType: values.fileType,
                });
                if (blob instanceof Blob) {
                  downloadBlob(blob, values.fileType);
                  toggle();
                }
              } finally {
                setLoading(false);
              }
            }}
          >
            <AvField
              type="select"
              name="fileType"
              label={t("File Type")}
              className="form-select"
              required
            >
              <option value="">{t("Select")}</option>
              {fileTypes.map((type) => (
                <option key={type} value={type}>
                  {type.toUpperCase()}
                </option>
              ))}
            </AvField>
            <ModalFooter className="d-flex justify-content-center pb-0">
              <Button type="submit" color="primary" disabled={loading}>
                {loading ? <i className="fa fa-spinner fa-spin" /> : t("Download")}
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </>
  );
};

export default withTranslation()(DownloadReportButton);
